module.exports = __webpack_public_path__ + "static/media/ThreeCircle.123606df.png";